import { render, staticRenderFns } from "./Clouds.vue?vue&type=template&id=742b10fa&scoped=true"
import script from "./Clouds.vue?vue&type=script&lang=js"
export * from "./Clouds.vue?vue&type=script&lang=js"
import style0 from "./Clouds.vue?vue&type=style&index=0&id=742b10fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b10fa",
  null
  
)

export default component.exports